// frontend/super-admin/src/components/Layout.jsx
import React, { useState, useEffect } from 'react';
import { Layout as AntLayout, Menu, Badge } from 'antd';
import { 
  DashboardOutlined, 
  UserOutlined, 
  LogoutOutlined, 
  CrownOutlined,
  DollarOutlined,
  SettingOutlined
} from '@ant-design/icons';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import api from '../services/api';

const { Header, Sider, Content } = AntLayout;

export default function Layout() {
  const [collapsed, setCollapsed] = useState(false);
  const [pendingPayments, setPendingPayments] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Fetch pending payments count
  useEffect(() => {
    fetchPendingCount();
    
    // Refresh every 30 seconds
    const interval = setInterval(fetchPendingCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchPendingCount = async () => {
    try {
      const response = await api.get('/api/payment-requests/pending/count');
      setPendingPayments(response.data.count);
    } catch (error) {
      console.error('Failed to fetch pending count');
    }
  };

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
    },
    {
      key: '/tenants',
      icon: <UserOutlined />,
      label: 'Tenants',
    },
    {
      key: '/plans',
      icon: <CrownOutlined />,
      label: 'Pricing Plans', // ✅ ADDED
    },
    {
      key: '/payment-requests',
      icon: <DollarOutlined />,
      label: (
        <Badge count={pendingPayments} offset={[10, 0]} size="small">
          <span style={{ color: '#fafafa', fontWeight: 'bold' }}>Payment Requests</span>
          
        </Badge>
      ),
    },
    {
      key: '/payment-settings',
      icon: <SettingOutlined />,
      label: 'Payment Settings',
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    navigate('/login');
  };

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
        <div style={{ 
          height: 64, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          color: 'white',
          fontSize: 18,
          fontWeight: 'bold'
        }}>
          {collapsed ? 'WA' : 'WhatsApp SaaS'}
        </div>
        
        <Menu
          theme="dark"
          selectedKeys={[location.pathname]}
          mode="inline"
          items={menuItems}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>

      <AntLayout>
        <Header style={{ 
          background: '#fff', 
          padding: '0 24px',
          display: 'flex',
          justifyContent: 'flex-end'
        }}>
          <Menu 
            mode="horizontal" 
            selectable={false}
            items={[
              {
                key: 'logout',
                icon: <LogoutOutlined />,
                label: 'Logout',
                onClick: handleLogout
              }
            ]}
          />
        </Header>

        <Content style={{ margin: '24px 16px', padding: 24, background: '#fff' }}>
          <Outlet />
        </Content>
      </AntLayout>
    </AntLayout>
  );
}